import { render, staticRenderFns } from "./DefaultPublic.vue?vue&type=template&id=52ed2848&"
import script from "./DefaultPublic.vue?vue&type=script&lang=js&"
export * from "./DefaultPublic.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPublic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports